import React, { useEffect, useState } from 'react';
import { connect } from 'react-redux';
import { SetCurrentPage } from '../../common/actions/pageAction';
import Pagenation from '../common/Pagenation';
import { GetEventList } from '../../common/actions/moreAction';
import Footbar from '../Layout/Footbar';
import { infiniteScroll } from '../../common/cores';


const EventCenter = (props) => {

    const [ active, setActive ] = useState(-1);

    const posts = props.more.event.posts

    const { page } = props;

    const getQuestions = (curpage) => {

        let params = {
          page: curpage,
          perPage: page.perPage,
          type: ""
        }
        props.GetEventList(params);
      }

      useEffect(()=> {
        getQuestions(1)
      }, [page.perPage])
      

      const onActive = (value) => { 
        // setNotice(notices[index]);
        if(active === value)
            setActive(-1)
        else 
            setActive(value)
    }


    return (
        <div id="scroll_parent" data-v-623d66c4="" className="content column right-content">
            
            <div id="scroll_main" data-v-24198fc6="" className="container_center">
                <div data-v-24198fc6="" className="height-100 mobile_scroll ps" id="layout3Container">
                    <div data-v-4c0b8fe6="" data-v-24198fc6="" className="bg_normal_1">
                        <div data-v-07085020="" data-v-4c0b8fe6="" className="padding-10px-lr padding-30px-bottom" >
                            <ul data-v-07085020="" className="list padding-50px-top padding-20px-bottom width-100 display-flex justify-content-center">
                                
                            </ul>
                                <ul data-v-47e23612="" className="estimate_list">
                                    {
                                        posts.map((list, index) => {
                                            return (
                                            <li data-v-2399d2bb="" key={index}>
                                                <div style={{display : 'flex'}} className='li_bottom li_title'>
                                                    <span data-v-2399d2bb="" style={{display :'flex', alignItems : 'center', paddingLeft : '50px'}}>{Number(page.curPage) * 10 + index - 9}</span>
                                                    <span data-v-2399d2bb="" style={{width: "0px"}}></span>
                                                    <span data-v-2399d2bb="" className="col" onClick={() => onActive(index)}>
                                                    <a data-v-2399d2bb="" aria-current="page" className="nuxt-link-exact-active nuxt-link-active col" style={{ cursor: "pointer", textAlign: "center" }}>
                                                        <span data-v-2399d2bb="" dangerouslySetInnerHTML={{ '__html': list.title }}>
                                                        </span>
                                                    </a>
                                                    </span>
                                                </div>

                                                <span data-v-2399d2bb="" style={{width: "0px"}}></span>
                                                <div data-v-2399d2bb="" className="xs-margin-5px-top " style={{display:active != index ? "none" : "block"}}>
                                                <div data-v-2399d2bb="" className="message text-center white-break-spaces li_bottom" style={{fontSize: "16px", backgroundColor: "#333644_" }}
                                                    dangerouslySetInnerHTML={{ '__html': list.content }}>
                                                </div>
                                                </div>
                                            </li>
                                            )
                                        })
                                    }
                                </ul>
                            <div data-v-4cb00781="" data-v-07085020="">
                                {
                                    posts.length !== 0 ? 
                                        <Pagenation
                                            page={page.curPage}
                                            totalPage={page.totalPage}
                                            getPage={getQuestions} />
                                        :
                                        <ul data-v-47e23612="" className="estimate_list">
                                            <li data-v-47e23612="">
                                                <div data-v-47e23612="" className="empty_item_1"
                                                    style={{ height: "150px", display: "flex", justifyContent: "center", alignItems: "center" }}>현재 등록된 게시물이 없습니다.</div>
                                            </li>
                                        </ul>
                                }
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    )
}

const mapStateToProps = state => ({
    user: state.user,
    page: state.page,
    more: state.more
})

export default connect(mapStateToProps, { SetCurrentPage, GetEventList })(EventCenter);


// WEBPACK FOOTER //
// ./src/components/Event/EventCenter.js